// extracted by mini-css-extract-plugin
export var legendIndicator = "_ee-1";
export var legendRight = "_ee-0";